import { render } from "./AddressDetails.vue?vue&type=template&id=4d48a4e0&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"

import "./AddressDetails.vue?vue&type=style&index=0&id=4d48a4e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d48a4e0"]])

export default __exports__